export default __webpack_public_path__ + "static/media/Rasoul-Logo.0fdd4071.jpg";